import React from 'react';
import {SegmentedControl} from '@forecast-it/design-system';

const STEPS = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9];

type WinProbabilitySegmentedControlProps = {
	value: number;
	onChange: (value: number) => void;
};

export const WinProbabilitySegmentedControl = ({value, onChange}: WinProbabilitySegmentedControlProps) => (
	<SegmentedControl
		value={String(value)}
		// Radix single ToggleGroup deselects on re-click (emits ''); ignore empty so a value is always held.
		onValueChange={(v: string) => {
			if (v) onChange(Number(v));
		}}
		data-cy="win-probability"
	>
		{STEPS.map(step => (
			<SegmentedControl.Item key={step} value={String(step)} label={`${Math.round(step * 100)}%`} data-cy={`win-${step}`}>
				{`${Math.round(step * 100)}%`}
			</SegmentedControl.Item>
		))}
	</SegmentedControl>
);
